module.exports = __webpack_public_path__ + "static/media/postgresql.91555248.png";